const mappedData = {
    audio: {
        description: (item, phrase) => {
            if (Object.keys(item.highlight).some(v => v == "description")) {
                return formatDescription(item.highlight.description[0], phrase)
            }
            return formatDescription(item._source.description, phrase)
        },
        title: item =>  {
            if (Object.keys(item.highlight).some(v => v == "name.keyword")) {
                return item.highlight["name.keyword"].join('')
            }
            if (Object.keys(item.highlight).some(v => v == "name")) {
                return item.highlight.name.join('')
            }
            return item._source.name
        },
        type: item => item._source.content_type,
        image: item => item._source.thumbnail,
        unitID: item => item._source.unit_ids[0],
        link: (item, unit, phrase) => {
            if ('fragmentDirective' in Location.prototype || 'fragmentDirective' in document) {
                let title = mappedData.audio.title(item)
                if (title.includes('<u>')) {
                    return `/audio/${unit}/${item._id}#:~:text=${title.replace(/<\/?u[^>]*>/g, '')}`
                }
                return `/audio/${unit}/${item._id}#:~:text=${mappedData.audio.description(item, phrase).replace(/<\/?u[^>]*>/g, '').replace('...', '')}`
            }
            return `/audio/${unit}/${item._id}`
        }
    },
    article: {
        description: (item, phrase) => {
            if (Object.keys(item.highlight).some(v => v == "content.body") && !(Object.keys(item.highlight).some(v => v == "name") && /(?:https?|ftp):\/\/[\n\S]+/g.test(item.highlight["content.body"].join(' ')))) {
                let index = 0
                for (let i = 0; i < item.highlight["content.body"].length && 1 < item.highlight["content.body"].length; i++) {
                    if (!/(?:https?|ftp):\/\/[\n\S]+/g.test(item.highlight["content.body"][i])) {
                        index = i
                        break
                    }
                }
                return formatDescription(item.highlight["content.body"][index], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "content.body.keyword") && !(Object.keys(item.highlight).some(v => v == "name") && /(?:https?|ftp):\/\/[\n\S]+/g.test(item.highlight["content.body.keyword"].join(' ')))) {
                let index = 0
                for (let i = 0; i < item.highlight["content.body.keyword"].length && 1 < item.highlight["content.body.keyword"].length; i++) {
                    if (!/(?:https?|ftp):\/\/[\n\S]+/g.test(item.highlight["content.body.keyword"][i])) {
                        index = i
                        break
                    }
                }
                return formatDescription(item.highlight["content.body.keyword"][index], phrase, true)
            }
            return formatDescription(item._source.description, phrase)
        },
        title: item =>  {
            if (Object.keys(item.highlight).some(v => v == "name.keyword")) {
                return item.highlight["name.keyword"].join('')
            }
            if (Object.keys(item.highlight).some(v => v == "name")) {
                return item.highlight.name.join('')
            }
            return item._source.name
        },
        type: item => item._source.content_type,
        image: item => item._source.thumbnail,
        unitID: item => item._source.unit_ids[0],
        link: (item, unit, phrase) => {
            if ('fragmentDirective' in Location.prototype || 'fragmentDirective' in document) {
                let title = mappedData.article.title(item)
                if (title.includes('<u>')) {
                    return `/text/${unit}/${item._id}#:~:text=${title.replace(/<\/?u[^>]*>/g, '')}`
                }
                return `/text/${unit}/${item._id}#:~:text=${mappedData.article.description(item, phrase).replace(/<\/?u[^>]*>/g, '').replace('...', '')}`
            }
            return `/text/${unit}/${item._id}`
        }
    },
    lesson: {
        description: (item, phrase) => {
            if (Object.keys(item.highlight).some(v => v == "description")) {
                return formatDescription(item.highlight.description[0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "description.keyword")) {
                return formatDescription(item.highlight["description.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "learning_goals.content.keyword")) {
                return formatDescription(item.highlight["learning_goals.content.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "learning_goals.content")) {
                return formatDescription(item.highlight["learning_goals.content"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "learning_goals.label")) {
                return formatDescription(item.highlight["learning_goals.label"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.body")) {
                return formatDescription(item.highlight["scenario_text_elements.body"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.body.keyword")) {
                return formatDescription(item.highlight["scenario_text_elements.body.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_video_elements.name")) {
                return formatDescription(item.highlight["scenario_video_elements.name"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "keywords.label.keyword")) {
                return formatDescription(item.highlight["keywords.label.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "keywords.label")) {
                return formatDescription(item.highlight["keywords.label"][0], phrase, true)
            }
            return formatDescription(item._source.description, phrase)
        },
        title: item =>  {
            if (Object.keys(item.highlight).some(v => v == "name.keyword")) {
                return item.highlight["name.keyword"].join('')
            }
            if (Object.keys(item.highlight).some(v => v == "name")) {
                return item.highlight.name.join('')
            }
            return item._source.name
        },
        type: item => item._source.content_type,
        image: item => item._source.thumbnail,
        unitID: item => item._source.unit_ids[0],
        link: (item, unit, phrase) => {
            let sectionTitle = getSectionTitle(item)
            let link = ''
            if (sectionTitle) {
                if (sectionTitle.subsection) {
                    link = `/lesson/${item._id}?section=${sectionTitle.section}&subsection=${sectionTitle.subsection}&uniqueid=${Date.now()}`
                } else {
                    link = `/lesson/${item._id}?section=${sectionTitle.section}&uniqueid=${Date.now()}`
                }
            } else {
                link = `/lesson/${item._id}`
            }

            if ('fragmentDirective' in Location.prototype || 'fragmentDirective' in document) {
                let title = mappedData.lesson.title(item)
                if (title.includes('<u>')) {
                    return `${link}#:~:text=${title.replace(/<\/?u[^>]*>/g, '')}`
                }
                return `${link}#:~:text=${mappedData.lesson.description(item, phrase).replace(/<\/?u[^>]*>/g, '').replace('...', '')}`
            }
            return link
        } 
    },
    teacher_lesson: {
        description: (item, phrase) => {
            if (Object.keys(item.highlight).some(v => v == "description.keyword")) {
                return formatDescription(item.highlight["description.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "description")) {
                return formatDescription(item.highlight.description[0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.title")) {
                return formatDescription(item.highlight["scenario_text_elements.title"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.body")) {
                return formatDescription(item.highlight["scenario_text_elements.body"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.body.keyword")) {
                return formatDescription(item.highlight["scenario_text_elements.body.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_video_elements.name")) {
                return formatDescription(item.highlight["scenario_video_elements.name"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "learning_goals.content")) {
                return formatDescription(item.highlight["learning_goals.content"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "learning_goals.label")) {
                return formatDescription(item.highlight["learning_goals.label"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "keywords.label.keyword")) {
                return formatDescription(item.highlight["keywords.label.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "keywords.label")) {
                return formatDescription(item.highlight["keywords.label"][0], phrase, true)
            }
            return formatDescription(item._source.description, phrase)
        },
        title: item =>  {
            if (Object.keys(item.highlight).some(v => v == "name.keyword")) {
                return item.highlight["name.keyword"].join('')
            }
            if (Object.keys(item.highlight).some(v => v == "name")) {
                return item.highlight.name.join('')
            }
            return item._source.name
        },
        type: item => item._source.content_type.replace(/_/g,' '),
        image: item => item._source.thumbnail,
        unitID: item => item._source.unit_ids[0],
        link: (item, unit, phrase) => {
            let sectionTitle = getSectionTitle(item)
            let link = ''
            if (sectionTitle) {
                if (sectionTitle.subsection) {
                    link = `/fagstoff/${item._id}?section=${sectionTitle.section}&subsection=${sectionTitle.subsection}&uniqueid=${Date.now()}`
                } else {
                    link = `/fagstoff/${item._id}?section=${sectionTitle.section}&uniqueid=${Date.now()}`
                }
            } else {
                link = `/fagstoff/${item._id}`
            }

            if ('fragmentDirective' in Location.prototype || 'fragmentDirective' in document) {
                let title = mappedData.teacher_lesson.title(item)
                if (title.includes('<u>')) {
                    return `${link}#:~:text=${title.replace(/<\/?u[^>]*>/g, '')}`
                }
                return `${link}#:~:text=${mappedData.teacher_lesson.description(item, phrase).replace(/<\/?u[^>]*>/g, '').replace('...', '')}`
            }
            return link
        } 
    },
    activity: {
        description: (item, phrase) => {
            if (Object.keys(item.highlight).some(v => v == "description")) {
                return formatDescription(item.highlight.description[0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "content.title")) {
                return formatDescription(item.highlight["content.title"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "content.body.keyword")) {
                return formatDescription(item.highlight["content.body.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "content.body")) {
                return formatDescription(item.highlight["content.body"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "content.instructions")) {
                return formatDescription(item.highlight["content.instructions"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "content.contextTitle")) {
                return formatDescription(item.highlight["content.contextTitle"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "content.description")) {
                return formatDescription(item.highlight["content.description"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "content.video_type.description")) {
                return formatDescription(item.highlight["content.video_type.description"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "content.video_text")) {
                return formatDescription(item.highlight["content.video_text"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "content.video_type.videoText")) {
                return formatDescription(item.highlight["content.video_type.videoText"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.body.keyword")) {
                return formatDescription(item.highlight["scenario_text_elements.body.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.body")) {
                return formatDescription(item.highlight["scenario_text_elements.body"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "video_text")) {
                return formatDescription(item.highlight["video_text"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "content.__component")) {
                return formatDescription(item.highlight["content.__component"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "name.keyword")) {
                return formatDescription(item.highlight["name.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "content.video_type.file.provider")) {
                return formatDescription(item.highlight["content.video_type.file.provider"][0], phrase)
            }
            return formatDescription(item._source.description, phrase)
        },
        title: item =>  {
            if (Object.keys(item.highlight).some(v => v == "name.keyword")) {
                return item.highlight["name.keyword"].join('')
            }
            if (Object.keys(item.highlight).some(v => v == "name")) {
                return item.highlight.name.join('')
            }
            return item._source.name
        },
        type: item => item._source.content_type,
        image: item => item._source.thumbnail,
        unitID: item => item._source.unit_ids[0],
        link: (item, unit, phrase) => {
            if ('fragmentDirective' in Location.prototype || 'fragmentDirective' in document) {
                let title = mappedData.activity.title(item)
                if (title.includes('<u>')) {
                    return `/video/${unit}/${item._id}#:~:text=${title.replace(/<\/?u[^>]*>/g, '')}`
                }
                let description = mappedData.activity.description(item, phrase)
                if (description) {
                    return `/video/${unit}/${item._id}#:~:text=${description.replace(/<\/?u[^>]*>/g, '').replace('...', '')}`
                }
            }
            return `/video/${unit}/${item._id}`
        }
    },
    unit: {
        description: (item, phrase) => {
            if (Object.keys(item.highlight).some(v => v == "description")) {
                return formatDescription(item.highlight.description[0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.body")) {
                return formatDescription(item.highlight["scenario_text_elements.body"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_video_elements.name")) {
                return formatDescription(item.highlight["scenario_video_elements.name"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "learning_goals.content")) {
                return formatDescription(item.highlight["learning_goals.content"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "learning_goals.label")) {
                return formatDescription(item.highlight["learning_goals.label"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "keywords.label.keyword")) {
                return formatDescription(item.highlight["keywords.label.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "keywords.label")) {
                return formatDescription(item.highlight["keywords.label"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "description.keyword")) {
                return formatDescription(item.highlight["description.keyword"][0], phrase, true)
            }
            return formatDescription(item._source.description, phrase)
        },
        title: item =>  {
            if (Object.keys(item.highlight).some(v => v == "name.keyword")) {
                return item.highlight["name.keyword"].join('')
            }
            if (Object.keys(item.highlight).some(v => v == "name")) {
                return item.highlight.name.join('')
            }
            return item._source.name
        },
        type: item => item._source.teacher_only ? 'Teacher Unit' : item._source.content_type,
        image: item => item._source.thumbnail,
        unitID: item => item._id,
        link: item => `/unit/${item._id}`
    },
    teacher_unit: {
        description: (item, phrase) => {
            if (Object.keys(item.highlight).some(v => v == "description")) {
                return formatDescription(item.highlight.description[0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "description.keyword")) {
                return formatDescription(item.highlight["description.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_video_elements.name")) {
                return formatDescription(item.highlight["scenario_video_elements.name"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.body.keyword")) {
                return formatDescription(item.highlight["scenario_text_elements.body.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.body")) {
                return formatDescription(item.highlight["scenario_text_elements.body"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "learning_goals.content")) {
                return formatDescription(item.highlight["learning_goals.content"][0], phrase)
            }
            if (Object.keys(item.highlight).some(v => v == "learning_goals.label")) {
                return formatDescription(item.highlight["learning_goals.label"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "keywords.label.keyword")) {
                return formatDescription(item.highlight["keywords.label.keyword"][0], phrase, true)
            }
            if (Object.keys(item.highlight).some(v => v == "keywords.label")) {
                return formatDescription(item.highlight["keywords.label"][0], phrase, true)
            }
            return formatDescription(item._source.description, phrase)
        },
        title: item =>  {
            if (Object.keys(item.highlight).some(v => v == "name.keyword")) {
                return item.highlight["name.keyword"].join('')
            }
            if (Object.keys(item.highlight).some(v => v == "name")) {
                return item.highlight.name.join('')
            }
            return item._source.name
        },
        type: item => item._source.content_type.replace(/_/g,' '),
        image: item => item._source.thumbnail,
        unitID: item => item._id,
        link: item => `/fagstoff/${item._id}`
    }
}

const truncate = (value, phrase, isTitle, num = 100) => {
    let valueToTruncate = value
    let start = 0
    let startInSpecialChars = false
    do {
      if (valueToTruncate.charAt(start) == "*" || valueToTruncate.charAt(start) == " " || valueToTruncate.charAt(start) == "," || valueToTruncate.charAt(start) == "." || valueToTruncate.charAt(start) == ">") {
        start += 1
        num += 1
        startInSpecialChars = true
      } else {
        startInSpecialChars = false
      }
    } while(startInSpecialChars)

    valueToTruncate = valueToTruncate.substring(start, valueToTruncate.length)
    start = 0
  
    let trunc
    if (valueToTruncate.length > num) {
      if (valueToTruncate.length < num * 2 && valueToTruncate.toLowerCase().indexOf('<u>') < valueToTruncate.length/2) {
        let endingInWord = false
        do {
            if (valueToTruncate.length > num && valueToTruncate.charAt(num) != " ") {
            num += 1
            endingInWord = true
            } else {
            endingInWord = false
            }
        } while(endingInWord)

        trunc = valueToTruncate.slice(start, num)
      } else {
        if (valueToTruncate.length > num * 2) {
            let loc = valueToTruncate.toLowerCase().indexOf('<u>')
            start = loc - (num / 2) > 0 ? loc - (num / 2) : 0
        } else {
            start = valueToTruncate.length - num
        }

        let startingBetweenWord = false
        do {
            if (start > 0 && valueToTruncate.charAt(start) != " ") {
                start -= 1
                startingBetweenWord = true
            } else {
                if(start !== 0) {
                    start += 1
                }
                
                startingBetweenWord = false
            }
        } while(startingBetweenWord)

        if (valueToTruncate.length > num * 2) {
            let loc = valueToTruncate.toLowerCase().indexOf('<u>')
            let endingInWord = false
            num = loc + (num / 2) <= valueToTruncate.length ? loc + (num / 2) : valueToTruncate.length

            do {
                if (valueToTruncate.length > num && valueToTruncate.charAt(num) != " ") {
                num += 1
                endingInWord = true
                } else {
                endingInWord = false
                }
            } while(endingInWord)
        } else {
            num = valueToTruncate.length
        }

        trunc = valueToTruncate.slice(start, num)
      }
  
      return trunc.charAt(trunc.length-1) === "." || trunc.charAt(trunc.length-1) === "?" ? trunc : `${trunc}...`
    }
    else {
      trunc = valueToTruncate.slice(start, valueToTruncate.length)
      return isTitle || trunc.length === 0 || trunc.charAt(trunc.length-1) === "." || trunc.charAt(trunc.length-1) === "?" ? trunc : `${trunc}...`
    }
}

const formatDescription = (description, phrase, isTitle = false) => {
    if (!description) {
        return          
    }
    
    description = description.replace('[]', '')
    //remove credit texts within small tag
    if (/<small>(.*\©.*)<\/small>/g.test(description)) {
        let descriptionCopy = description.replace(/<small>(.*\©.*)<\/small>/g, '')
        if (!description.includes(phrase) || descriptionCopy.includes(phrase)) {
            description = descriptionCopy
        }
    }
    //remove ul and li tags
    description = description.replace('\n* ', '')
    description = description.replace('\n\n**', ' ')
    description = description.replace(/\*\*/g, '')
    
    //removing trailing numbers
    description = description.replace(/[\n]{1,}[0-9]+\.$/g, '')
    //remove anchor tags
    description = description.replace(/<\/?a[^>]*>/g, '')
    //remove incomplete anchor tags
    if (description.includes('<a')) {
        description = description.slice(0, description.indexOf('<a'))
    }
    //remove incomplete tags in the begining
    description = description.trim()
    if (!description.split(' ')[0].includes('<') && description.split(' ')[0].includes('>')) {
        description = description.slice(description.indexOf('>'), description.length)
    }
    //remove link inside brackets
    description = description.replace(/(?:\(https?|ftp):\/\/[\n\S]+/g, '')
    //remove other links
    description = description.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '')
    //remove asterisk used for markdown
    description = description.replace(/\*/g, '')
    
    return truncate(description, phrase, isTitle, 105)
}

const getSectionTitle = (item) => {
    let result = ''
    if (Object.keys(item.highlight).some(v => v == "description.keyword")) {
        return
    }
    if (Object.keys(item.highlight).some(v => v == "description")) {
        return
    }
    if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.title")) {
        result = item.highlight["scenario_text_elements.title"][0]
    } else if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.body.keyword")) {
        result = item.highlight["scenario_text_elements.body.keyword"][0]
    } else if (Object.keys(item.highlight).some(v => v == "scenario_text_elements.body")) {
        result = item.highlight["scenario_text_elements.body"][0]
    }

    if (result !== '') {
        //replace underline tag between search phrase added by the es
        let formattedResult = result.replace(/<\/?u[^>]*>/g, '')

        for (let i = 0; i < item._source.scenario_text_elements.length; i++) {
            if (item._source.scenario_text_elements[i].title.includes(formattedResult)) {
                return { section: item._source.scenario_text_elements[i].title.replace(/[^a-zA-Z]/g, "").toLowerCase() }
            }
            else if (item._source.scenario_text_elements[i].body.includes(formattedResult)) {
                if (item._source.scenario_text_elements[i].body.includes('### ')) {
                    if (result.includes('###')) {
                        let splittedResult = result.split('### ')
                        for(let j = 0; j < splittedResult.length; j++) {
                            if (splittedResult[j].includes('<u>')){
                                result = splittedResult[j]
                            }
                        }
                    }

                    result = result.replace(/<\/?u[^>]*>/g, '')
                    let splittedScenario = item._source.scenario_text_elements[i].body.split('### ')
                    let index = 0
                    if (!item._source.scenario_text_elements[i].body.startsWith('#')) {
                        index = 1
                    }
                    for(let j = index; j < splittedScenario.length; j++) {
                        if (splittedScenario[j].includes(result)){
                            return { 
                                section: item._source.scenario_text_elements[i].title.replace(/[^a-zA-Z]/g, "").toLowerCase(),
                                subsection: splittedScenario[j].substring(0, splittedScenario[j].indexOf("\n")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase()
                            }
                        }
                    }

                }
                
                return { section: item._source.scenario_text_elements[i].title.replace(/[^a-zA-Z]/g, "").toLowerCase() }
            }
        }
    }
    return
}
export default mappedData;